module.exports = __webpack_public_path__ + "static/Perfume23-99cd99337ca3193becfc5be30b4f76b3.jpg";